import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonPrimary from '../../../Common/Button/Primary/ButtonPrimary';
import ButtonSecondary from '../../../Common/Button/Secondary/ButtonSecondary';
import { useTranslation } from 'react-i18next';
import styles from './WelcomePageMobile.module.scss';
import { ReactComponent as Logo } from "../../../../assets/images/logo.svg";
import background from '../../../../assets/images/auth_background_mobile.png';
import LayoutMobileFixedHeight from '../../../Common/Mobile/Layout/FixedHeight/LayoutMobileFixedHeight';

function WelcomePageMobile() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <LayoutMobileFixedHeight>
      <div className={styles.container}>
        <div className={styles.top}  style={{ backgroundImage: `url(${background})` }}>
          <Logo className={styles.logo}/>
        </div>
        <div className={styles.bot}>
          <div className={styles.content}>
            <span className={styles.description}>{t('login.welcome.description')}</span>
          </div>
          <ButtonPrimary label={t('login.welcome.button.create_account')} onClick={() => navigate('/auth/signup')}/>
          <ButtonSecondary label={t('login.welcome.button.log_in')} onClick={() => navigate('/auth/login')}/>
        </div>
      </div>
    </LayoutMobileFixedHeight>
  )
}

export default WelcomePageMobile;
